import React, { useEffect, useState } from "react";
import Title from "../components/Title";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PerformanceAppraisalPDF from "./PerformanceAppraisalPDF";
import { toByteArray } from "base64-js";

// icons
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { FileUpload, UploadFile } from "@mui/icons-material";
import FileUploadIcon from "@mui/icons-material/FileUpload";

import { useSelector } from "react-redux";
import dataService from "../services/data-service";
import { toast } from "react-toastify";
import { use } from "react";
import Upload from "antd/es/upload/Upload";

const PerformanceAppraisal = () => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isDownloading, setisDownloading] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [performanceImage, setPerformanceImage] = useState();

  // const [previewPerformance, setPreviewPerformance] = useState()
  // console.log('previewPerformance', previewPerformance)
  const [file, setFile] = useState(null);
  const [enableUploadButton, setEnableUploadButton] = useState(false);

  var user = useSelector((state) => state.user.user);
  var admin = useSelector((state) => state.admin.admin);
  var userClickedByAdmin = useSelector(
    (state) => state.adminClickedUser.clickedUser
  );
  var loggedInData = null;

  if (user) {
    loggedInData = user;
  } else if (userClickedByAdmin) {
    loggedInData = userClickedByAdmin;
  } else {
    // Handle the case where no one is logged in
  }
  const {
    name,
    address,
    gender,
    supervisorName,
    trainingCenter,
    imageUrl,
    candidateNumber,
    courseName,
    internStartDate,
    internEndDate,
    userId,
  } = loggedInData;

  // this below admin data will only be used for the validation case of if admin with role PartnerCenter and userclicked by admin also then we dont allow them to edit any user
  const adminData = admin;
  const adminRole = adminData?.role;
  // console.log("adminRole", adminRole);

  const fields = [
    "Name :",
    "Candidate Registration No :",
    "Name of Organization :",
    "Department/s :",
    "Duration From :",
    "Duration To :",
  ];

  const fieldValues = [
    name,
    candidateNumber,
    trainingCenter,
    courseName,
    internStartDate.split("T")[0],
    internEndDate.split("T")[0],
  ];
  const handleUploadFile = () => {
    document.getElementById("hiddenFileInput").click();
  };

  const handlePDFFile = async (event) => {
    const file = event.target.files[0];

    const MAX_SIZE = 2 * 1024 * 1024; // 2MB
    if (file.size && file.size > MAX_SIZE) {
      toast.error("Please upload file under 2MB ");
      return;
    }
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const result = reader.result;
        // setPreviewPerformance(result); // Set the preview image

        setEnableUploadButton(true);
        handleFileUpload(file, result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDownloadAppraisal = () => {
    setisDownloading(true);
    const fetchData = async () => {
      try {
        // Fetch the base64-encoded PDF data
        const response = await dataService.getData(
          `/PerformanceAppraisal/downloadPerformanceAppraisal?userid=${userId}`
        );

        // Assuming response contains base64 string
        let base64String = response; // This should be your base64 encoded PDF

        // Check if the string is URL-safe and replace characters if needed
        base64String = base64String.replace(/-/g, "+").replace(/_/g, "/");

        // Add padding if necessary
        const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
        base64String += padding;

        // Decode base64 string to binary data using base64-js
        const byteArray = toByteArray(base64String);

        // Create a Blob from the binary data
        const blob = new Blob([byteArray], { type: "application/pdf" });

        // Create a link to download the PDF
        const link = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = "Performance_Appraisal.pdf"; // Filename for the PDF
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        console.error("Error downloading performance appraisal:", err);
      } finally {
        setisDownloading(false);
      }
    };

    fetchData();
  };

  const handleFileUpload = async (file, result) => {
    const formData = new FormData();
    formData.append("performanceForm", file);
    setIsUploading(true);

    // const uploadPdf = async () => {
    try {
      const response = await dataService.patchData(
        `/PerformanceAppraisal/upload?UserId=${userId}`,
        formData
      );
      // window.location.reload();
      // handleUploadFile();
      if (response?.performanceForm) toast.success("Uploaded Successfully");
      setFile(result); // Set this too for previewing in the form
    } catch (err) {
      toast.error("Error uploading performance appraisal");
    } finally {
      setIsUploading(false);
    }
  };
  const getMimeType = (imageUrl) => {
    // You may need to inspect the base64 string or use additional metadata if available
    if (imageUrl.startsWith("/9j/")) {
      return "image/jpeg";
    } else if (imageUrl.startsWith("iVBORw0KGgo")) {
      return "image/png";
    } else if (imageUrl.startsWith("R0lGODlh")) {
      return "image/gif";
    }
    return "application/pdf"; // Default to JPEG if unknown
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await dataService.getData(
          `/PerformanceAppraisal/get?userId=${userId}`
        );
        // console.log('response', response.performanceForm)
        setPerformanceImage(response.performanceForm);
      } catch (error) {
        toast.error("Could not retrive data");
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [userId]);

  useEffect(() => {
    if (performanceImage) {
      const mimeType = getMimeType(performanceImage);
      const dataUrl = `data:${mimeType};base64,${performanceImage}`;
      // setPreviewPerformance(dataUrl)
      setFile(dataUrl);
    }
  }, [performanceImage]);

  return (
    <div className="m-4 md:m-8">
      <div className="flex justify-between">
        <div className={` hidden md:block `}>
          <Title title="Performance Appraisal Form" />
        </div>
        <div className="block md:hidden w-full">
          <Title title="Performance Appraisal" />
        </div>
        <div className="hidden md:block">
          <button
            className="flex justify-end items-center text-[14px] font-poppins gap-x-1 p-2 bg-primary-title rounded-[5px] px-6 text-white cursor-pointer"
            onClick={handleDownloadAppraisal}
          >
            {isDownloading ? (
              <svg
                aria-hidden="true"
                role="status"
                className="inline w-7 h-7 me-3 text-white animate-spin "
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="#E5E7EB"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentColor"
                />
              </svg>
            ) : (
              <>
                <FileDownloadIcon />
                <span className="font-poppins">Download Raw Form</span>
              </>
            )}
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 text-sm md:text-lg md:grid-cols-2 lg:grid-cols-3 gap-6 -mx-8 mt-4 bg-primary-background p-8">
        {fields.map((field, index) => (
          <div key={index} className="flex gap-x-4 md:text-sm xl:text-[14px]">
            <div className="font-poppins text-nowrap">{field}</div>
            <div className="font-poppins text-gray-400 ">
              {fieldValues[index]}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6">
        <span className="font-poppins text-sm md:text-[14px] ">
          Please describe the trainee's performance in the following areas. You
          are welcome to share your own observations on the trainee that may
          help his or her overall success during the placement.
        </span>
      </div>
      <div className="mt-6">
        <div className="flex flex-col gap-2 md:flex md:flex-row lg:gap-20 text-sm md:text-[14px]">
          <span className="font-poppins font-bold ">Grading Systems:</span>
          <span className="font-poppins">1-Unsatisfactory</span>
          <span className="font-poppins">2-Fair</span>
          <span className="font-poppins">3-Good</span>
          <span className="font-poppins">4-Excellent</span>
        </div>
      </div>

      <div className=" mt-6  md:hidden">
        <span className="font-poppins font-bold ">Download Appraisal Form</span>

        <button
          className="flex justify-center mt-2 items-center  text-lg gap-x-1 p-2 bg-primary-title rounded-[5px] px-4 text-white cursor-pointer w-full"
          onClick={handleDownloadAppraisal}
        >
          <FileDownloadIcon />
          <span className="font-poppins">Download</span>
        </button>
      </div>

      {isLoading ? (
        <div className="flex justify-center items-center w-full mt-32">
          <svg
            aria-hidden="true"
            role="status"
            className="inline h-12 w-12 md:w-28 md:h-28 me-3 text-primary-title animate-spin "
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="#E5E7EB"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentColor"
            />
          </svg>
        </div>
      ) : (
        <div className="">
          <div
            className="flex cursor-pointer mt-4 bg-primary-background border-2 border-dotted border-gray-400 rounded-md p-2 w-fit"
            onClick={handleUploadFile}
          >
            {file ? (
              <div className="flex flex-col flex-wrap">
                {/* <iframe
                  src={file}
                  title="Performance Preview"
                  className="h-[800px] w-full sm:w-[794px]"
                  frameBorder="0"
                /> */}
                <div className="bg-white">
                  {isUploading ? (
                    <div className="h-[842px] w-full sm:w-[595px] object-contain justify-center flex items-center">
                      <svg
                        aria-hidden="true"
                        role="status"
                        className="inline h-12 w-12 md:w-28 md:h-28 me-3 text-primary-title animate-spin "
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="#E5E7EB"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentColor"
                        />
                      </svg>
                    </div>
                  ) : (
                    <img
                      src={file}
                      className="max-h-[421px] max-w-[421px] w-full object-contain"
                    />
                  )}
                </div>

                <div className="flex items-center justify-center text-lg font-bold text-primary-title text-opacity-50 hover:text-opacity-100 w-full sm:w-auto">
                  <div className="text-center mx-3 hover:underline">
                    Change Appraisal Form
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="inline ml-2 lucide lucide-upload-icon lucide-upload"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="17 8 12 3 7 8" />
                      <line x1="12" x2="12" y1="3" y2="15" />
                    </svg>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                {adminData?.role !== "PartnerCenter" ? (
                  <div className="flex  gap-2 ">
                    <span className="color-gray">
                      <FileUploadIcon />
                    </span>
                    <span className="font-poppins font-bold text-[14px]">
                      Upload Appraisal
                    </span>
                  </div>
                ) : (
                  <span className="font-poppins text--[14px]">
                    No Performance Appraisal Uploaded By Student
                  </span>
                )}
              </div>
            )}
            <input
              type="file"
              accept="image/png, image/jpeg, image/jpg"
              id="hiddenFileInput"
              className="hidden"
              style={{ display: "none" }}
              onChange={(e) => {
                handlePDFFile(e);
              }}
              disabled={adminRole === "PartnerCenter"}
            />
          </div>

          {/* {adminRole !== "PartnerCenter" && (
            <div className="mt-4">
              <button
                onClick={handleFileUpload}
                type="button"
                className={`flex justify-end items-center gap-x-1 p-2 bg-primary-title rounded-[5px] px-6 text-white ${
                  enableUploadButton ? "cursor-pointer" : ""
                } mt-5 text-lg`}
                disabled={!enableUploadButton}
                id="upload"
              >
                {isUploading ? (
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-7 h-7 me-3 text-white animate-spin "
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                ) : (
                  <span className="font-poppins text-[14px]">
                    Confirm Upload
                  </span>
                )}
              </button>
            </div>
          )} */}
        </div>
      )}
    </div>
  );
};

export default PerformanceAppraisal;
